<template>
  <div xs12 sm12 md12 lg12 xl12 v-if="fullscreen">
    <v-layout row>
      <v-flex>
          <GChart
            type="LineChart"
            :data="chartData"
            :options="chartOptions"
          />
      </v-flex>
    </v-layout>
  </div>
  <div  mb-3 v-else>  


    <v-card class="widget pa-0" :class=widgetStyle>
      
      <widget-header :widget=metricWidget v-on:fullscreen="goFullScreen"></widget-header>
      <v-layout row class="pa-1" :class="widgetHeight">
        <v-flex xs12 align-self-end>

          <GChart
            type="LineChart"
            :data="chartData"
            :options="chartOptions"
          />

        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import "@/assets/styles/styles.css";
import WidgetHeader from "@/components/metrics/WidgetHeader.vue"
import { GChart } from 'vue-google-charts'
import Helpers from "@/helpers.js"
import WidgetMixin from "@/components/metrics/WidgetMixin.js"

export default {
  name: "TrendlineWidget",
  mixins: [WidgetMixin],
  components: {WidgetHeader, GChart},
  computed: {
    minY() {
      if (this.metricWidget.chartData) {
        let min = undefined
        for (const row of this.metricWidget.chartData) {
          for (let index = 1; index < row.length; index++) {
            if (min === undefined || row[index].v < min) {
              min = row[index].v
            }
          }
        }
        if (min!==undefined) {
          return min * 0.80 
        }
      }
    },    
    maxY() {
      if (this.metricWidget.chartData) {
        let max = undefined
        for (const row of this.metricWidget.chartData) {
          for (let index = 1; index < row.length; index++) {
            if (max === undefined || row[index].v > max) {
              max = row[index].v
            }
          }
        }
        if (max!==undefined) {
          return max * 1.20
        }
      }
    },
    chartOptions() {
      const options = {}
      if (this.fullscreen) {
        options.width = "100%"
        options.height = window.innerHeight - 72 
        options.theme = 'maximized'
      } else {
        options.width = "100%"
        options.height = 140*this.metricWidget.height;
        options.theme = null
        options.chartArea = {
          width: "90%",
          height: ["70%", "85%", "90%"][this.metricWidget.height-1]
        }        
      }
      options.backgroundColor = { fill:'transparent' }
      options.legend = { position: 'none' }
      options.vAxis = {}
      options.hAxis = {}
      if (!this.layoutMode) {
        options.explorer = { 
              actions: ['dragToZoom', 'rightClickToReset'],
              axis: 'horizontal',
              keepInBounds: true,
              maxZoomIn: 4.0}
      }


      const maxVAxis = this.maxY
      const minVAxis = this.minY
      if (maxVAxis) {
        options.vAxis.viewWindow = { max: maxVAxis } 
      }

      if (this.widgetStyle === 'widget-style-blue') {
        options.vAxis.textStyle = { color: '#fff' }
        options.hAxis.textStyle = { color: '#fff' }
      }

      const currency = this.currencySymbol
      if (currency) {
        options.vAxis.format = `${currency}#,###.##`
      }

      if (this.isTimebased) {
        const avg = (maxVAxis+minVAxis) / 2
        const early = Helpers.durationToWords(minVAxis)
        const middle = Helpers.durationToWords(avg)
        const late = Helpers.durationToWords(maxVAxis)
        options.vAxis.ticks = [{v:minVAxis, f:early}, {v:avg, f:middle}, {v:maxVAxis, f:late}]
      }
      return options
    }
  },
};
</script>